module.exports = __webpack_public_path__ + "img/18.2e8ae1cd.png";